// frontend/src/farm/footprint.mjs
// Vehicle areas (spec 2026-09-28-farm-3-vehicles-design.md): the tapped cell is the area's
// FRONT corner — the cell nearest the viewer, largest x + y — and the n × n area stretches
// back, up the screen. At the fence it slides back inside so it always keeps its full size.
// Pure (node --test).
import { cellCentre, cellKey } from './iso.mjs';

const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

export function areaCells(front, n, size) {
  const fx = clamp(front.x, n - 1, size - 1), fy = clamp(front.y, n - 1, size - 1);
  const cells = [];
  for (let dx = 0; dx < n; dx++) for (let dy = 0; dy < n; dy++) cells.push({ x: fx - n + 1 + dx, y: fy - n + 1 + dy });
  return cells.sort((a, b) => (a.x + a.y) - (b.x + b.y) || a.x - b.x);   // back to front
}

export function areaKey(cells) { return cellKey(cells[0].x, cells[0].y); }

export function areaCentre(cells, size) {
  let x = 0, y = 0;
  for (const c of cells) { const p = cellCentre(c.x, c.y, size); x += p.x; y += p.y; }
  return { x: x / cells.length, y: y / cells.length };
}

// Every cell edge as a segment between grid corners (cell (x, y) spans corners x..x+1, y..y+1),
// each shared edge once — FarmWorld draws them all, the way FarmVille outlines every plot.
export function areaEdges(cells) {
  const seen = new Map();
  const add = (x0, y0, x1, y1) => seen.set(`${x0},${y0},${x1},${y1}`, [x0, y0, x1, y1]);
  for (const { x, y } of cells) {
    add(x, y, x + 1, y); add(x, y + 1, x + 1, y + 1);
    add(x, y, x, y + 1); add(x + 1, y, x + 1, y + 1);
  }
  return [...seen.values()];
}
